module.exports = __webpack_public_path__ + "img/CU.2757ee28.png";